import {
  TrainingCustomInterface,
  TrainingCustomState,
} from "module/trainingCustom/types";

export const isTrainingCustomStateScheduledOrLower = (
  trainingCustom: TrainingCustomInterface
): boolean => TrainingCustomState.scheduled === trainingCustom.state;
